<script setup lang="ts">
import type { TooltipContentEmits, TooltipContentProps } from "reka-ui";
import { reactiveOmit } from "@vueuse/core";
import {
  TooltipArrow,
  TooltipContent,

  useForwardPropsEmits,
} from "reka-ui";

const props = defineProps<TooltipContentProps & { variant?: TooltipBox["variant"] }>();
const emits = defineEmits<TooltipContentEmits>();

const propsOmit = reactiveOmit(props, ["variant"]);
const forwarded = useForwardPropsEmits(propsOmit, emits);
</script>

<script lang="ts">
import type { VariantProps } from "class-variance-authority";
import { cva } from "class-variance-authority";

export type TooltipBox = VariantProps<typeof tooltipBox>;

const tooltipBox = cva([
  "rounded-sm px-2 py-1 text-white select-none",
], {
  variants: {
    variant: {
      primary: "bg-slate-800",
      destructive: "bg-red-600",
    },
  },
  defaultVariants: {
    variant: "primary",
  },
});

const tooltipArrow = cva([

], {
  variants: {
    variant: {
      primary: "fill-slate-800",
      destructive: "fill-red-600",
    },
  },
  defaultVariants: {
    variant: "primary",
  },
});
</script>

<template>
  <TooltipContent
    v-bind="forwarded"
    avoid-collisions
    :collision-padding="5"
    :side-offset="props.sideOffset ?? 2"
    class="z-20 text-xs"
  >
    <div :class="tooltipBox({ variant })">
      <slot />
    </div>
    <TooltipArrow :class="tooltipArrow({ variant })" />
  </TooltipContent>
</template>
